
function DateNav({ value, onChange }) {
  function shift(days) {
    const d = new Date(value + 'T12:00:00');
    d.setDate(d.getDate() + days);
    onChange(d.toISOString().slice(0, 10));
  }
  const label = new Date(value + 'T12:00:00').toLocaleDateString('fr-FR', {
    weekday: 'short', day: '2-digit', month: 'short', year: 'numeric'
  });
  const isToday = value === new Date().toISOString().slice(0, 10);
  return (
    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
      <button className="btn-ghost btn-sm" onClick={() => shift(-1)} style={{ padding: '4px 8px', fontWeight: 700 }}>‹</button>
      <span style={{ fontWeight: 600, fontSize: '0.88rem', minWidth: 160, textAlign: 'center', cursor: isToday ? 'default' : 'pointer', color: isToday ? 'var(--primary)' : 'inherit' }}
        onClick={() => !isToday && onChange(new Date().toISOString().slice(0, 10))}
        title={isToday ? "Aujourd'hui" : "Revenir à aujourd'hui"}>
        {label}
      </span>
      <button className="btn-ghost btn-sm" onClick={() => shift(1)} style={{ padding: '4px 8px', fontWeight: 700 }}>›</button>
      {!isToday && <button className="btn-ghost btn-sm" onClick={() => onChange(new Date().toISOString().slice(0, 10))} style={{ fontSize: '0.72rem' }}>Auj.</button>}
    </div>
  );
}
import { useEffect, useState } from 'react';
import { api } from '../api/client';

const STATUS = {
  PRESENT:  ['green',  'Présent'],
  ABSENT:   ['red',    'Absent'],
  CONGE:    ['gold',   'Congé'],
  MALADIE:  ['orange', 'Maladie'],
  AUTRE:    ['navy',   'Autre'],
};

const TYPES = { ENSEIGNANT: 'Enseignant', SOUTIEN: 'Soutien', ADMINISTRATIF: 'Administratif' };

export default function StaffAttendance() {
  const [tab, setTab] = useState('pointage');
  return (
    <>
      <div className="tabs" style={{ marginBottom: 4 }}>
        <button className={`tab ${tab === 'pointage' ? 'active' : ''}`} onClick={() => setTab('pointage')}>Pointage du jour</button>
        <button className={`tab ${tab === 'historique' ? 'active' : ''}`} onClick={() => setTab('historique')}>Historique</button>
        <button className={`tab ${tab === 'rapport' ? 'active' : ''}`} onClick={() => setTab('rapport')}>Rapport d'assiduité</button>
      </div>
      {tab === 'pointage' && <Pointage />}
      {tab === 'historique' && <HistoriqueAgent />}
      {tab === 'rapport' && <RapportAttendance />}
    </>
  );
}

function Pointage() {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [staff, setStaff] = useState([]);
  const [records, setRecords] = useState({});
  const [error, setError] = useState('');
  const [saving, setSaving] = useState({});
  const [flash, setFlash] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [reasonModal, setReasonModal] = useState(null);

  function load() {
    api.get('/attendance/staff').then(setStaff).catch((e) => setError(e.message));
    api.get(`/attendance?date=${date}`).then((r) => {
      const m = {};
      (r || []).forEach((rec) => { m[rec.staffId] = rec; });
      setRecords(m);
    }).catch((e) => setError(e.message));
  }

  useEffect(load, [date]);

  async function mark(staffId, status, reason = '') {
    if ((status === 'ABSENT' || status === 'MALADIE' || status === 'AUTRE') && !reason) {
      setReasonModal({ staffId, status });
      return;
    }
    setSaving((p) => ({ ...p, [staffId]: true }));
    try {
      const rec = await api.post(`/attendance/${staffId}?date=${date}`, { status, reason: reason || null });
      setRecords((p) => ({ ...p, [staffId]: rec }));
      const name = staff.find((s) => s.id === staffId)?.lastName || '';
      setFlash(`${name} — ${STATUS[status][1]}`);
      setTimeout(() => setFlash(''), 2500);
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving((p) => ({ ...p, [staffId]: false }));
    }
  }

  const filtered = staff.filter((s) => !typeFilter || s.type === typeFilter);
  const stats = {
    present: Object.values(records).filter((r) => r.status === 'PRESENT').length,
    absent: Object.values(records).filter((r) => r.status === 'ABSENT').length,
    conge: Object.values(records).filter((r) => r.status === 'CONGE').length,
    maladie: Object.values(records).filter((r) => r.status === 'MALADIE').length,
    non_marque: filtered.filter((s) => !records[s.id]).length,
  };

  const dateLabel = new Date(date + 'T12:00:00').toLocaleDateString('fr-FR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <>
      <div className="kpi-grid">
        <div className="kpi green"><span>Présents</span><strong>{stats.present}</strong></div>
        <div className="kpi"><span>Absents</span><strong>{stats.absent}</strong></div>
        <div className="kpi gold"><span>Congés</span><strong>{stats.conge}</strong></div>
        <div className="kpi"><span>Maladie</span><strong>{stats.maladie}</strong></div>
        <div className="kpi navy"><span>Non marqués</span><strong>{stats.non_marque}</strong></div>
      </div>

      <div className="panel">
        <div className="panel-head">
          <h2>Pointage — {dateLabel}</h2>
          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <select className="search-input" style={{ width: 160 }} value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
              <option value="">Tous les types</option>
              {Object.entries(TYPES).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
            <DateNav value={date} onChange={setDate} />
          </div>
        </div>
        <div className="panel-body">
          {error && <div className="form-error">{error}</div>}
          {flash && <div className="receipt-banner">{flash}</div>}
          {filtered.length === 0 ? <div className="empty">Aucun agent.</div> : (
            <div className="table-wrap"><table>
              <thead>
                <tr><th>Agent</th><th>Type</th><th>Statut</th><th>Actions</th></tr>
              </thead>
              <tbody>{filtered.map((s) => {
                const rec = records[s.id];
                const status = rec?.status || null;
                const [bc, bl] = status ? STATUS[status] : ['', ''];
                return (
                  <tr key={s.id}>
                    <td>
                      <b>{s.lastName} {s.firstName}</b>
                      <br /><small className="mono" style={{ color: 'var(--muted)' }}>{s.matricule}</small>
                    </td>
                    <td>{TYPES[s.type] || s.type}</td>
                    <td>
                      {status
                        ? <><span className={`badge ${bc}`}>{bl}</span>{rec?.reason ? <small style={{ marginLeft: 6, color: 'var(--muted)' }}>({rec.reason})</small> : ''}</>
                        : <span className="badge">Non marqué</span>
                      }
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                        {Object.entries(STATUS).map(([v, [col, l]]) => (
                          <button
                            key={v}
                            className={`btn-sm ${status === v ? 'btn' : 'btn-ghost'}`}
                            onClick={() => mark(s.id, v)}
                            disabled={saving[s.id]}
                            style={{ padding: '3px 8px', fontSize: '0.72rem' }}
                          >{l}</button>
                        ))}
                      </div>
                    </td>
                  </tr>
                );
              })}</tbody>
            </table></div>
          )}
        </div>
      </div>

      {reasonModal && (
        <ReasonModal
          status={reasonModal.status}
          onConfirm={(reason) => { mark(reasonModal.staffId, reasonModal.status, reason); setReasonModal(null); }}
          onCancel={() => setReasonModal(null)}
        />
      )}
    </>
  );
}

function ReasonModal({ status, onConfirm, onCancel }) {
  const [reason, setReason] = useState('');
  return (
    <div className="modal-overlay">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Motif — {STATUS[status][1]}</h2>
        <div className="field">
          <label>Motif / précision</label>
          <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={3} placeholder="Précisez le motif..." />
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 12 }}>
          <button className="btn-ghost" onClick={onCancel}>Annuler</button>
          <button className="btn" onClick={() => onConfirm(reason)}>Confirmer</button>
        </div>
      </div>
    </div>
  );
}

function HistoriqueAgent() {
  const [staff, setStaff] = useState([]);
  const [selected, setSelected] = useState('');
  const [history, setHistory] = useState([]);
  const [error, setError] = useState('');
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get('/attendance/staff').then(setStaff).catch((e) => setError(e.message)); }, []);

  useEffect(() => {
    if (!selected) return;
    api.get(`/attendance/history/${selected}`).then((data) => {
      setHistory(data || []);
      const s = { present: 0, absent: 0, conge: 0, maladie: 0, autre: 0 };
      (data || []).forEach((h) => { s[h.status?.toLowerCase()] = (s[h.status?.toLowerCase()] || 0) + 1; });
      setStats(s);
    }).catch((e) => setError(e.message));
  }, [selected]);

  return (
    <div className="panel">
      <div className="panel-head"><h2>Historique des présences</h2></div>
      <div className="panel-body">
        {error && <div className="form-error">{error}</div>}
        <div className="field" style={{ marginBottom: 14 }}>
          <label>Sélectionner un agent</label>
          <select value={selected} onChange={(e) => setSelected(e.target.value)}>
            <option value="">—</option>
            {staff.map((s) => <option key={s.id} value={s.id}>{s.lastName} {s.firstName} ({s.matricule})</option>)}
          </select>
        </div>

        {stats && (
          <div className="kpi-grid" style={{ marginBottom: 14 }}>
            <div className="kpi green"><span>Présent</span><strong>{stats.present}</strong></div>
            <div className="kpi"><span>Absent</span><strong>{stats.absent}</strong></div>
            <div className="kpi gold"><span>Congé</span><strong>{stats.conge}</strong></div>
            <div className="kpi"><span>Maladie</span><strong>{stats.maladie}</strong></div>
          </div>
        )}

        {!selected ? <div className="empty">Sélectionnez un agent.</div> : history.length === 0 ? <div className="empty">Aucun enregistrement.</div> : (
          <div className="table-wrap"><table>
            <thead><tr><th>Date</th><th>Jour</th><th>Statut</th><th>Motif</th></tr></thead>
            <tbody>{history.map((h) => {
              const [bc, bl] = STATUS[h.status] || ['gray', h.status];
              return (
                <tr key={h.id}>
                  <td className="mono">{new Date(h.date).toLocaleDateString('fr-FR')}</td>
                  <td>{new Date(h.date).toLocaleDateString('fr-FR', { weekday: 'long' })}</td>
                  <td><span className={`badge ${bc}`}>{bl}</span></td>
                  <td>{h.reason || '—'}</td>
                </tr>
              );
            })}</tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}

function RapportAttendance() {
  const [from, setFrom] = useState(() => { const d = new Date(); d.setDate(d.getDate() - 30); return d.toISOString().slice(0, 10); });
  const [to, setTo] = useState(new Date().toISOString().slice(0, 10));
  const [typeFilter, setTypeFilter] = useState('');
  const [rows, setRows] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function generate() {
    setLoading(true); setError('');
    try {
      const r = await api.get(`/attendance/report?from=${from}&to=${to}`);
      setRows(r || []);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  const filtered = rows.filter((r) => !typeFilter || r.staff?.type === typeFilter);

  return (
    <div className="panel">
      <div className="panel-head"><h2>Rapport d'assiduité</h2></div>
      <div className="panel-body">
        {error && <div className="form-error">{error}</div>}
        <div className="grid-3" style={{ marginBottom: 14 }}>
          <div className="field"><label>Du</label><input type="date" value={from} onChange={(e) => setFrom(e.target.value)} /></div>
          <div className="field"><label>Au</label><input type="date" value={to} onChange={(e) => setTo(e.target.value)} /></div>
          <div className="field"><label>Type</label>
            <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
              <option value="">Tous</option>
              {Object.entries(TYPES).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </div>
        </div>
        <button className="btn btn-sm" onClick={generate} disabled={loading} style={{ marginBottom: 14 }}>
          {loading ? 'Génération…' : 'Générer le rapport'}
        </button>

        {filtered.length === 0 ? <div className="empty">Lancez une génération.</div> : (
          <div className="table-wrap"><table>
            <thead>
              <tr>
                <th>Agent</th><th>Type</th>
                <th className="num">Présent</th>
                <th className="num">Absent</th>
                <th className="num">Congé</th>
                <th className="num">Maladie</th>
                <th className="num">Autre</th>
                <th className="num">Total jours</th>
                <th className="num">% Assiduité</th>
              </tr>
            </thead>
            <tbody>{filtered.map((r, i) => {
              const pct = r.total > 0 ? Math.round((r.present / r.total) * 100) : 0;
              const color = pct >= 90 ? 'green' : pct >= 75 ? 'gold' : 'red';
              return (
                <tr key={i}>
                  <td><b>{r.staff?.lastName} {r.staff?.firstName}</b><br /><small className="mono">{r.staff?.matricule}</small></td>
                  <td>{TYPES[r.staff?.type] || '—'}</td>
                  <td className="num">{r.present}</td>
                  <td className="num">{r.absent}</td>
                  <td className="num">{r.conge}</td>
                  <td className="num">{r.maladie}</td>
                  <td className="num">{r.autre || 0}</td>
                  <td className="num">{r.total}</td>
                  <td className="num"><span className={`badge ${color}`}>{pct}%</span></td>
                </tr>
              );
            })}</tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}
